import { render, staticRenderFns } from "./CustomiseCover.vue?vue&type=template&id=652236c9&scoped=true&"
import script from "./CustomiseCover.vue?vue&type=script&lang=js&"
export * from "./CustomiseCover.vue?vue&type=script&lang=js&"
import style0 from "./CustomiseCover.vue?vue&type=style&index=0&id=652236c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652236c9",
  null
  
)

export default component.exports